import CoreBase from '../services/engines/CoreBase';

class PercentageCalculator extends CoreBase {
    calcDiff = (old, newValue) => {
        if (old === 0) return 0;

        var result = (newValue / old) * 100 - 100;
        return result.toFixed(2);
    };

    /**
     *
     * @param {number} value the value
     * @param {number} percentage the percentage to add or substract
     * @returns number: 100 - 10% = 90
     */
    add = (value, percentage) => {
        return parseFloat(value) + parseFloat(percentage) * (parseFloat(value) / 100);
    };

    /**
     * subtract percentage from value v - p%
     *
     *
     * @param {number} value
     * @param {*} percentage
     * @returns
     */
    subtract = (value, percentage) => {
        var v = parseFloat(value);

        return v - (parseFloat(percentage) * v) / 100;
    };

    /**
     * get percentage value of value so
     * 10% of 100 = 10
     *
     * @param {*} value
     * @param {*} percentage
     * @returns
     */
    get = (value, percentage) => {
        return (value / 100) * percentage;
    };
}

const percentageCalculator = new PercentageCalculator();
export default percentageCalculator;
